import { render } from "./CircleProgress.vue?vue&type=template&id=5c038c2c"
import script from "./CircleProgress.vue?vue&type=script&lang=js"
export * from "./CircleProgress.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__